export function cdnBaseURL(assetRelativePath: string) {
  const cdnPath =
    process.env.VUE_APP_CDN_BASE_URL || 'https://assets.twism.com/dashboard';

  return cdnPath + assetRelativePath;
}
